import Contabilidad from "../Contabilidad.vue";
import ListaIngresos from "../ingresos/ListaIngresos.vue";
import FormIngreso from "../ingresos/FormIngreso.vue";
import ListaGastos from "../gastos/ListaGastos.vue";
import FormGasto from "../gastos/FormGasto.vue";
import FormUpdateGasto from "../gastos/FormUpdateGasto.vue";
import rutas_ventas from "../ventas_diarias/rutas/rutas_ventas.js";
import ventas_kit_digital from "../ventas_kit_digital/rutas/rutas_ventas.js";
import marketing from "../marketing/rutas/rutas_marketing.js";
import TiposGasto from "../gastos/TiposGasto.vue";

import Lote from "../Lote.vue";

const routes = [
    ...route(`/contabilidad`, Contabilidad, {
        Auth: true,
    }),
    ...route(`/lista-ingresos`, ListaIngresos, {
        Auth: true,
    }),
    ...route("/guardar-ingreso", FormIngreso, {
        Auth: true,
    }),
    ...route(`/lista-gastos`, ListaGastos, {
        Auth: true,
    }),
    ...route("/guardar-gasto", FormGasto, {
        Auth: true,
    }),
    ...route("/update-gasto/:id", FormUpdateGasto, {
        Auth: true,
    }),
    ...route("/enviar-facturas", Lote, {
        Auth: true,
    }),
    ...route(`/tipos-gasto`, TiposGasto, {
        Auth: true,
    }),
    ...rutas_ventas,
    ...ventas_kit_digital,
    ...marketing,
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
